import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ContentService from '../../../apiclients/ContentService';
import Loader from '../Loader';
import Icon from '@projeccions-pdc/react-icon';
import MailShareDialog from '../MailShareDialog/MailShareDialog';
import Dialog from '@material-ui/core/Dialog';
import AppContext from '../../../AppContext';
import { createShareLink, striptags } from '../../../helpers';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import CustomMailShareDialog from '../../KerryLogistics/CustomMailShareDialog';
import LocalizedStrings from '../../Localization/localization';
import './Share.css';

class ShareMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            loading: false,
        };
    }

    //TODO: calculate expiry date
    //TODO: posar nom localitzat a la url
    handleShareClick = () => {
        if (this.state.open) {
            this.setState({ open: true, shareToken: undefined });
        } else {
            let appContext = new AppContext();
            let platformConfig = appContext.getPlatformConfig();

            let tempInDays = platformConfig.shareExpireInDays ? platformConfig.shareExpireInDays : 30;
            let now = new Date();
            let expireDate = now.setDate(now.getDate() + tempInDays);

            this.setState({ loading: true });
            let ids = [];
            if (this.props.currentContent.children) {
                ids = this.props.currentContent.children;
            }
            ids.push(this.props.currentContent.contentId);

            ContentService.shareContent(this.props.currentContent.shareURL, ids, expireDate)
                .then((data) => {
                    this.setState({ shareToken: data.shareToken, loading: false, open: true });
                })
                .catch((err) => {
                    console.log(err.message);
                    this.props.notify('error', LocalizedStrings.errorShareLink);
                    this.setState({ loading: false });
                });
        }
    };

    handleClickOutside = (evt) => {
        this.setState({ open: false, shareToken: undefined });
    };

    handleShareError = (err) => {
        console.log(err);
    };

    handleShareSuccess = () => {
        this.setState({ open: false });
    };

    render() {
        let appContext = new AppContext();
        const shareEnabled = this.props.currentContent && this.props.currentContent.contentType !== 'c';
        return (
            <div
                className={this.props.children ? '' : 'fe-share'}
                data-id="share-inside"
                style={this.props.children ? { display: 'inline-block' } : undefined}
            >
                {this.props.children ? (
                    <div style={{ display: 'inline-block' }} onClick={shareEnabled ? this.handleShareClick : undefined}>
                        {this.props.children(this.state.loading)}
                    </div>
                ) : (
                    <div className={'fe-menu-button'} onClick={shareEnabled ? this.handleShareClick : undefined}>
                        {this.state.loading ? <Loader loading={true} size={'20px'} /> : <Icon name="md-share" size={'20px'} />}
                    </div>
                )}
                <Dialog fullScreen={this.props.fullScreen} open={this.state.open && !this.state.loading} onClose={this.handleClickOutside}>
                    {this.state.open &&
                        /* FIXME: customization for kerry demo */
                        (appContext.getPlatformId() === 'kerrylogistics' ? (
                            <CustomMailShareDialog
                                attachments={[
                                    {
                                        name: this.props.currentContent ? striptags(this.props.currentContent.name) : '',
                                        url: createShareLink(
                                            this.props.currentContent.contentId,
                                            this.props.currentContent.contentType,
                                            this.props.currentContent.name,
                                            this.state.shareToken
                                        ),
                                        identifier: this.props.currentContent ? 'content~' + this.props.currentContent.contentId : '',
                                        resourceSubtype: this.props.currentContent ? this.props.currentContent.contentType : '',
                                        // icon: 'fa-bars'
                                    },
                                ]}
                                notify={this.props.notify}
                                onError={this.handleShareError}
                                onSuccess={this.handleShareSuccess}
                                onClose={this.handleClickOutside}
                            />
                        ) : (
                            <MailShareDialog
                                attachments={[
                                    {
                                        name: this.props.currentContent ? striptags(this.props.currentContent.name) : '',
                                        url: createShareLink(
                                            this.props.currentContent.contentId,
                                            this.props.currentContent.contentType,
                                            this.props.currentContent.name,
                                            this.state.shareToken
                                        ),
                                        identifier: this.props.currentContent ? 'content~' + this.props.currentContent.contentId : '',
                                        resourceSubtype: this.props.currentContent ? this.props.currentContent.contentType : '',
                                        shareToken: this.state.shareToken,
                                        // icon: 'fa-bars'
                                    },
                                ]}
                                notify={this.props.notify}
                                onError={this.handleShareError}
                                onSuccess={this.handleShareSuccess}
                                onClose={this.handleClickOutside}
                            />
                        ))}
                </Dialog>
            </div>
        );
    }
}
ShareMenu.propTypes = {
    currentContent: PropTypes.object,
    notify: PropTypes.func.isRequired,
    children: PropTypes.func,
    fullScreen: PropTypes.bool.isRequired,
};
const Share = withRouter(withMobileDialog()(ShareMenu));

export default Share;
